<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t('invoices.attachments') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/dashboard" v-if="userType=='super_admin'">{{ $t('general.home') }}</router-link>
          <router-link slot="item-title" to="/supplier/dashboard" v-else-if="userType=='supplier'">{{ $t('general.home') }}</router-link>
          <router-link slot="item-title" to="/anchor/dashboard" v-else-if="userType=='anchor'">{{ $t('general.home') }}</router-link>
          <router-link slot="item-title" to="/funder/dashboard" v-else-if="userType=='funder'">{{ $t('general.home') }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/purchase-orders" v-if="userType=='super_admin'">{{ $tc('pos.po', 2) }}</router-link>
          <router-link slot="item-title" to="/supplier/purchase-orders" v-else-if="userType=='supplier'">{{ $tc('pos.po', 2) }}</router-link>
          <router-link slot="item-title" to="/anchor/purchase-orders" v-else-if="userType=='anchor'">{{ $tc('pos.po', 2) }}</router-link>
          <router-link slot="item-title" to="/funder/purchase-orders" v-else-if="userType=='funder'">{{ $tc('pos.po', 2) }}</router-link>
        </li>
        <li class="breadcrumb-item">
            <router-link slot="item-title" to="#">{{ $tc('invoices.attachments', 2) }}</router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div class="col-xs-2 mr-4"  v-if="userType=='anchor' && POStatus=='DRAFT'">
          <base-button
            size="large"
            icon="plus"
            color="theme"
            @click="addAttachment"
           >
            {{ $t('invoices.newAttachment') }}
          </base-button>
        </div>
      </div>
    </div>
    <SinglePORow :fetchData="fetchData" :tableDivId="tableDivId"/>

    <div v-cloak v-show="showEmptyScreen" class="col-xs-1 no-data-info" align="center">
      <astronaut-icon class="mt-5 mb-4"/>
      <div class="row" align="center">
        <label class="col title">{{ $t('invoices.no_attachments') }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{ $t('invoices.list_of_attachments') }}</label>
      </div>
      <div class="btn-container" v-if="userType=='anchor' && POStatus=='DRAFT'">
        <base-button
          :outline="true"
          color="theme"
          class="mt-3"
          size="large"
          @click="addAttachment"
        >
          {{ $t('invoices.add_new_attactment') }}
        </base-button>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">{{ $t('general.showing') }}: <b>{{ POAttachments.length }}</b></p>

        <transition name="fade">
          <v-dropdown v-if="selectedPOAttachments.length" :show-arrow="false">
            <span slot="activator" href="#" class="table-actions-button dropdown-toggle">
              {{ $t('general.actions') }}
            </span>
            <v-dropdown-item v-if="userType=='anchor' && POStatus=='DRAFT'">
              <div class="dropdown-item" @click="removeMultipleAttachments"  >
                <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                {{ $t('general.delete') }}
              </div>
            </v-dropdown-item>
          </v-dropdown>
        </transition>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          id="select-all"
          v-model="selectAllFieldStatus"
          type="checkbox"
          class="custom-control-input"
          @change="selectAllPOAttachments"
        >
        <label for="select-all" class="custom-control-label selectall">
          <span class="select-all-label">{{ $t('general.select_all') }} </span>
        </label>
      </div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="POAttachments"
        table-class="table"
      >
      <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-checkbox">
              <input
                :id="row.id"
                v-model="selectField"
                :value="row.id"
                type="checkbox"
                class="custom-control-input"
              >
              <label :for="row.id" class="custom-control-label"/>
            </div>
          </template>
        </table-column>
       <table-column
       :label="$tc('documents.documentType', 1)"
       show="documentType.name"
       />
        <table-column
       :label="$t('documents.document')"
       show="name"
       />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span> {{ $t('customers.action') }} </span>
            <v-dropdown>
                <a slot="activator" href="#"><dot-icon /></a>
                <v-dropdown-item>
                   <div class="dropdown-item">
                       <a  :href="row.path"  target="_blank" v-if="row.path">
                            <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                            {{ $t('general.view') }}
                        </a>
                   </div>
                </v-dropdown-item>
                <v-dropdown-item v-if="userType=='anchor' && POStatus=='DRAFT'">
                    <div class="dropdown-item" @click="deleteDocument(row)">
                        <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                        {{ $t('general.delete') }}
                    </div>
                </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import AstronautIcon from '../../components/icon/AstronautIcon'
import SinglePORow from './SinglePurchaseOrderRow'
export default {
    components: {
    AstronautIcon,
    SinglePORow
  },
  data () {
    return {
        isRequestOngoing: true,
        filtersApplied: false,
        userType:'',
        fetchData:[],
        tableDivId:"tableDivId",
        POStatus:null

      }
    },
 created(){
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    else if(localStorage.getItem('account_type')=='anchor'){
      this.userType='anchor';

    }else if(localStorage.getItem('account_type')=='supplier'){
      this.userType='supplier';
    }
    else if(localStorage.getItem('account_type')=='funder'){
      this.userType='funder';
    }
    this.loadPO();
    this.Attachments();
  },
 computed: {
     ...mapGetters('documentType', [
      'POAttachments',
      'totalPOAttachments',
      'selectedPOAttachments'
    ]),
    showEmptyScreen () {
      return !this.totalPOAttachments  && !this.isRequestOngoing
    },
     selectField: {
      get: function () {
        return this.selectedPOAttachments
      },
      set: function (val) {
        this.selectPOAttachment(val)
      }
    },
    selectAllFieldStatus: {
      get: function () {
        return this.selectAllField
      },
      set: function (val) {
        this.setSelectAllPOState(val)
      }
    },
   },
 methods: {
    ...mapActions('po', [
      'fetchPO',
      'SinglePOArray'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('documentType', [
      'deletePOAttachment',
      'fetchPOAttachments',
      'selectAllPOAttachments',
      'setSelectAllPOState',
      'selectPOAttachment',
      'deleteMultiplePOAttachments'
    ]),
    async loadPO () {
      let response = await this.SinglePOArray(this.$route.params.id)
      if (response.data) {
        this.fetchData =response.data.purchaseOrder;
        this.POStatus =response.data.purchaseOrder[0].status;
      }
    },
    async addAttachment () {
      this.openModal({
        'title': 'Add Attachment',
        'componentName': 'POAttachmentModal'
      })
    },
    async Attachments(){
        const data = {
            purchase_order_id: this.$route.params.id
        }
        let response = await this.fetchPOAttachments(data)
        this.isRequestOngoing = false
    },
     async deleteDocument(row){
        swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('pos.confirm_attachment_delete'),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
           let data={
            'attachment_id':row.id,
            'purchase_order_id':this.$route.params.id
            }
        let res =  await this.deletePOAttachment(data)
        if(res.data.result=='success'){
            window.toastr['success'](this.$tc('general.deleteAttachment_message'))
            this.Attachments();
        }else if (res.data.error) {
            window.toastr['error'](res.data.message)
          }
        }
      })
    },
     async removeMultipleAttachments () {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('pos.confirm_attachment_delete', 2),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
            let data={
            'attachment_ids':this.selectedPOAttachments,
            'purchase_order_id':this.$route.params.id
            }
          let request = await this.deleteMultiplePOAttachments(data)
          if (request.data.result=='success') {
            window.toastr['success'](this.$tc('general.deleteAttachment_message', 2))
            this.Attachments();
          } else if (request.data.error) {
            window.toastr['error'](request.data.message)
          }
        }
      })
    }
 }
}
</script>
<style scoped>
#tableDivId{
  min-height: 0px;
}
</style>
